const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgFlujoCajaHolding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "50.314mm",
    height: "40.262mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5031.4 4026.2",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE",
      fillRule: "nonzero"
    },
    d: "M433.83 4.48l4149 0c119.52,0 228.71,49.17 308.48,128.45l1.7 1.69c78.97,79.73 127.88,188.7 127.88,307.92l0 3145.06c0,120.81 -49.21,230.38 -128.45,309.62 -8.66,8.66 -17.75,16.61 -27.16,23.92 -76.76,65.15 -175.48,104.53 -282.45,104.53l-4149 0c-120.8,0 -230.37,-49.21 -309.61,-128.45 -79.24,-79.24 -128.45,-188.81 -128.45,-309.62l0 -3145.06c0,-119.79 49.4,-229.24 129.02,-309.05l-0.57 -0.56c79.24,-79.24 188.81,-128.45 309.61,-128.45zm246.24 1184.79l3656.56 0c66.77,0 121.41,-54.67 121.41,-121.44l0 -379.06c0,-66.84 -54.72,-121.4 -121.41,-121.4l-3656.56 0c-66.69,0 -121.44,54.63 -121.44,121.4l0 379.06c0,66.69 54.67,121.44 121.44,121.44zm768.51 2189.82l0 -379.1c0,-66.58 -54.68,-121.44 -121.37,-121.44l-641.15 0c-66.73,0 -121.4,54.75 -121.4,121.44l0 379.1c0,66.73 54.74,121.36 121.4,121.36l641.15 0c66.58,0 121.37,-54.78 121.37,-121.36zm2888.05 -500.54l-2313.97 0c-66.69,0 -121.36,54.75 -121.36,121.44l0 379.1c0,66.73 54.59,121.36 121.36,121.36l2313.97 0c66.77,0 121.41,-54.56 121.41,-121.36l0 -379.1c0,-66.76 -54.79,-121.44 -121.41,-121.44zm-2313.97 -1158.87c-66.62,0 -121.36,54.71 -121.36,121.41l0 379.05c0,66.77 54.59,121.44 121.36,121.44l2313.97 0c66.77,0 121.41,-54.59 121.41,-121.44l0 -379.05c0,-66.77 -54.72,-121.41 -121.41,-121.41l-2313.97 0zm-574.08 121.41c0,-66.58 -54.68,-121.41 -121.37,-121.41l-647.14 0c-66.69,0 -121.44,54.71 -121.44,121.41l0 379.05c0,66.77 54.82,121.44 121.44,121.44l647.14 0c66.58,0 121.37,-54.82 121.37,-121.44l0 -379.05z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlujoCajaHolding);
export default __webpack_public_path__ + "static/media/flujoCajaHolding.353f485955eb17508f2c80ab478cc093.svg";
export { ForwardRef as ReactComponent };